import { ScriptDef } from '../../types';
import { SHORT_SCRIPTS } from './short';
import { VARIETY_SCRIPTS } from './variety';
import { WEB_SCRIPTS } from './web';
import { TV_GUZHUANG_SCRIPTS } from './tv-guzhuang';
import { TV_DUSHI_SCRIPTS } from './tv-dushi';
import { TV_ZHIYE_SCRIPTS } from './tv-zhiye';
import { TV_XUANYI_SCRIPTS } from './tv-xuanyi';
import { TV_JUNLV_SCRIPTS } from './tv-junlv';
import { MOVIE_AIQING_SCRIPTS } from './movie-aiqing';
import { MOVIE_XIANSHI_SCRIPTS } from './movie-xianshi';
import { MOVIE_FANZUI_SCRIPTS } from './movie-fanzui';
import { MOVIE_DONGZUO_SCRIPTS } from './movie-dongzuo';
import { MOVIE_DAPIAN_SCRIPTS } from './movie-dapian';
import { MOVIE_DADAO_SCRIPTS } from './movie-dadao';
import { MOVIE_XIJU_SCRIPTS } from './movie-xiju';
import { MOVIE_XIAOCHENGBEN_SCRIPTS } from './movie-xiaochengben';
/**
 * 剧本池（普通剧本）
 * 每个剧本有唯一 ID，属性要求和关联 NPC 通过 ID 引用
 *
 * 多角色结构（2026-09 定稿）：
 *  - 每本剧本可有多个角色（roles[]）：女一号/男一号/女二号/配角…，玩家可试镜任一角色；
 *  - **剧本不分等级，角色分等级**（1-10，与咖位等级同构）：角色等级 = 咖位要求，判定 role.level <= player.rank 即可试
 *    （咖位 Lv.1 也可接 Lv.1 角色，试镜行程无咖位门槛）；
 *  - **拍摄期是剧级（2026-09-28 统一档期批）**：= ⌈最小番位角色 shootWeeks ÷ 4⌉ 个月（ScriptSystem.scriptShootMonths），
 *    全剧组统一档期、同杀青同开播；各角色自己的 shootWeeks 另作该角色合同作废期限的基准。
 *    属性成长（attributeGrowth）/片酬（reward）仍为角色级：同一剧本不同角色成长/酬劳各不相同；
 *  - **名气为剧本级 heat 派生**：角色名气加成 = heat × 统一番位系数（GameConfig.FAME_BILLING_FACTORS，
 *    一番 ×1.0 / 二番 ×0.7 / 三番 ×0.5 / 四番 ×0.2 / 五番 ×0.1 / 无番位 ×0.5），见 ScriptSystem.fameGainOf；
 *  - **themes（题材标签）**：剧本级字段，第一个为主题材，其余为副题材；heat = round(baseScore × 类型系数 × 题材系数)，
 *    见 ScriptSystem.computeHeat / GameConfig.GENRE_HEAT_FACTORS / THEME_FACTORS；
 *  - 整剧进市场池：抽中剧本 a，其角色 b/c/d 一起开始试镜；只有落在主角咖位可见档位内的角色进池；
 *  - 主角不签的角色随机派给普通 NPC（见 NormalNpcSystem / GameState.sweepUnclaimedRoles）；
 *  - 角色 gender：'male'/'female' 按主角性别过滤试镜；'any'（综艺嘉宾等）不限性别。
 *
 * 注：特殊剧本（主线剧情解锁）不在本池中，后续以独立结构实现（见项目文档）。
 * 结算：实际评分 = baseScore + 番位系数 × Σ(主角属性−角色要求)/25（clamp 2-10；四番及以后属性不计，评分为纯 baseScore），口碑 = (实际评分−6)×2；
 * 名气 = heat × 统一番位系数、片酬按角色 reward 结算。
 *
 */

export const SCRIPTS: ScriptDef[] = [
    ...SHORT_SCRIPTS,
    ...VARIETY_SCRIPTS,
    ...WEB_SCRIPTS,
    ...TV_GUZHUANG_SCRIPTS,
    ...TV_DUSHI_SCRIPTS,
    ...TV_ZHIYE_SCRIPTS,
    ...TV_XUANYI_SCRIPTS,
    ...TV_JUNLV_SCRIPTS,
    ...MOVIE_AIQING_SCRIPTS,
    ...MOVIE_XIANSHI_SCRIPTS,
    ...MOVIE_FANZUI_SCRIPTS,
    ...MOVIE_DONGZUO_SCRIPTS,
    ...MOVIE_DAPIAN_SCRIPTS,
    ...MOVIE_DADAO_SCRIPTS,
    ...MOVIE_XIJU_SCRIPTS,
    ...MOVIE_XIAOCHENGBEN_SCRIPTS,
];

/** 按 ID 索引 */
export const SCRIPT_MAP: Record<string, ScriptDef> = {};
SCRIPTS.forEach(s => { SCRIPT_MAP[s.id] = s; });
